import { render, staticRenderFns } from "./BlogTag.vue?vue&type=template&id=49dcea57&"
import script from "./BlogTag.vue?vue&type=script&lang=js&"
export * from "./BlogTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports